import './index.scss'

import React from 'react'

import { bindActionCreators } from 'redux'
import { connect }            from 'react-redux'
import { withRouter, Link }   from 'react-router-dom'

import prettysize from '../../../utils'
import { Modal, message, Alert, Spin, Popconfirm } from 'antd'
import CloudFlyerAPI from "../../../api/CloudFlyerAPI"
import moment from "moment"

let $this  = null
class SetAlert extends React.Component {
    constructor() {
        super()
        this.state = {
            loading : false,
            save_loading : false,

            // UI state
            visibleModal: false,
            loadingSave: false,

            // Alert model
            id     : null,
            type   : 'SIZE',
            unit   : 'MB',
            limit  : 0,
            alerts : []
        }

        this.units = [
            'MB',
            'GB',
            'TB'
        ]

        this.handleCloseModal = this.handleCloseModal.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleSaveClick = this.handleSaveClick.bind(this)
        this.handleEditClick = this.handleEditClick.bind(this)
        this.handleAddClick = this.handleAddClick.bind(this)
        this.handleDeleteClick = this.handleDeleteClick.bind(this)

        $this = this
    }

    componentDidMount() {
        this.refresh()
    }

    componentWillReceiveProps(nextProps) {
        // Reset to initial state when write operations are done
        this.setState({
            loadingSave: false,
            id: null,
            visibleModal: false,
            cloud_account : nextProps.cloud_account
        })
    }

    handleChange(e) {
        const { name, value } = e.target
        // input handling
        this.setState({
            [name]: value
        })
    }

    handleAddClick() {
        this.setState({
            type: 'SIZE',
            unit: 'MB',
            limit: 0,
            visibleModal: true
        })
    }

    refresh = () =>{
        this.setState({loading:true})
        CloudFlyerAPI
            .notifications
            .all()
            .then(res =>{
                if($this.props.storage){
                    return $this.setState({alerts:((res||{}).data||{}).filter(a => a.bucket_name === $this.props.storage.bucket_name), loading:false})
                }
                $this.setState({alerts:((res||{}).data||{}), loading:false})
            })
            .catch(e =>{
                $this.setState({loading:false})
                console.error(e)
            })
    }

    handleDeleteClick = id => {
        $this.setState({loading:true})
        CloudFlyerAPI.notifications
            .delete(id)
            .then(()=>{
                message.success('Alert deleted successfully')
                $this.refresh()
            })
            .catch(e =>{
                $this.setState({loading:false})
                message.error(e.message)
                console.log(e)
            })
    }

    handleEditClick(id) {
        const { alerts } = this.props
        const { unit } = this.state
        let alert = alerts.find(x => x.id === id)
        if (alert.type === 'SIZE') {
            // convert from bytes to selected unit
            alert = {
                ...alert,
                limit: alert.limit / Math.pow(1024, this.units.indexOf(unit) + 2)
            }
        }
        // Open edit modal
        this.setState({
            ...alert,
            id,
            visibleModal: true
        })
    }

    handleSaveClick() {
        let { limit, type, unit, id } = this.state
        if (type === 'SIZE') {
            limit = limit * Math.pow(1024, this.units.indexOf(unit) + 2)
        }

        $this.setState({save_loading: true})
        CloudFlyerAPI.notifications
            .create(this.props.cloud_account.id, this.props.storage ? this.props.storage.bucket_name : null, type === 'SIZE' ? limit : null, type === 'SIZE' ? null : limit)
            .then(res =>{
                $this.setState({alerts:((res||{}).data||{}), save_loading:false, visibleModal:false}, $this.refresh)
            })
            .catch(e =>{
                $this.setState({save_loading:false})
                console.error(e.message)
                message.error(e.message)
            })
    }

    handleCloseModal() {
        this.setState({
            visibleModal: false,
            id: null
        })
    }

    render() {
        const {loading, error, cloud_account={}, storage={}} = this.props
        const {alerts, visibleModal, type, limit, unit, save_loading} = this.state

        if (loading) {
            return (
                <div style={{ textAlign: 'center' }}>
                    <Spin/>
                </div>
            )
        }

        if (error) {
            return <Alert
                message='Server error'
                description='Something went wrong while fetching your alerts, please try again.'
                type='error'
                showIcon
            />
        }

        return (
            <div className='set-alert'>
                <div className='header'>
                    <h1>
                        Set up notifications for
                        <span style={{ fontWeight: 'bold' }}> {storage ? storage.bucket_name : cloud_account.project_name} </span>
                    </h1>
                    <Link to='/'> Go back </Link>
                </div>
                <button className='btn primary' onClick={this.handleAddClick}>
                    set new alert
                </button>
                <div className='alert-list'>
                    {alerts && alerts.map(alert =>
                        <AlertItem
                            key={alert.id} {...alert}
                            handleEditClick={this.handleEditClick} handleDeleteClick={this.handleDeleteClick}
                        />)}
                </div>
                <EditModal
                    {...this.state}
                    handleChange={this.handleChange} handleSaveClick={this.handleSaveClick}
                    handleCloseModal={this.handleCloseModal}
                />
            </div>
        )
    }
}

const CostInput = ({ limit, onChange }) => (
    <input
        type='number' value={limit}
        className='input' name='limit'
        onChange={onChange}
    />
)

const SizeInput = ({ limit, unit, onChange }) => (
    <div>
        <input
            type='number' value={limit} style={{ width: '80%' }}
            className='input' name='limit'
            onChange={onChange}
        />
        <select
            className='input' value={unit} name='unit' style={{ width: '20%' }}
            onChange={onChange}
        >
            <option value='MB'>MB</option>
            <option value='GB'>GB</option>
            <option value='TB'>TB</option>
        </select>
    </div>
)

const AlertItem = ({ id, kind, size_limit, cost_limit, last_notified = 'Mon Jan 15 2018 18:55:22 GMT+0000 (WET)', handleEditClick, handleDeleteClick }) => (
    <div className='alert-item'>
        <p>
            Notify me when the
            <span style={{ fontWeight: 'bold' }}> {kind.toLowerCase()} </span>
            reaches
            {kind === 'size' ?
                <span style={{ fontWeight: 'bold' }}> {prettysize(size_limit)} </span> :
                <span style={{ fontWeight: 'bold' }}> ${size_limit ? size_limit : cost_limit} </span>}

            <br/>
            <span className={'last-notify'}>{last_notified ? ('Last notified ' + moment(last_notified).fromNow()): ''}</span>
        </p>
        <div>
            {/*<button className='btn' onClick={handleEditClick.bind(null, id)}>
        edit
      </button>*/}
            <Popconfirm
                title='Are you sure you want to delete this notification ?'
                okText='Yes' cancelText='No'
                onConfirm={handleDeleteClick.bind(null, id)}>
                <button className='btn danger'> delete </button>
            </Popconfirm>
        </div>
    </div>
)

const EditModal = ({
                       visibleModal,
                       type,
                       limit,
                       unit, save_loading,
                       handleChange,
                       handleSaveClick,
                       handleCloseModal
                   }) => (
    <Modal
        visible={visibleModal} footer={null}
        onCancel={handleCloseModal}
    >
        <div className='set-alert-form'>
            <div className='header'>
                <h3>Set new alert</h3>
            </div>
            <div className='input-group'>
                <label>Set notification on:</label>
                <select
                    className='input' value={type} name='type'
                    onChange={handleChange}
                >
                    <option value='SIZE'>size</option>
                    <option value='COST'>cost</option>
                </select>
            </div>
            <div className='input-group'>
                <label>Limit value: {type === 'COST' && 'USD'}</label>
                {
                    type === 'COST' ?
                        <CostInput limit={limit} onChange={handleChange} /> :
                        <SizeInput limit={limit} unit={unit} onChange={handleChange} />
                }
            </div>
            <button className='btn' onClick={handleCloseModal}>cancel</button>
            <button className='btn primary' onClick={handleSaveClick} >
                save {save_loading && <Spin size='small' />}
            </button>
        </div>
    </Modal>
)

function mapStateToProps({ alerts, cloudAccounts }, { match, history }) {

    const { items } = cloudAccounts
    if (items.length === 0) {
        history.push('/')
    }

    let cloud_account = items.find(i => i.id === match.params.id||(i.id||'').toString() === match.params.id)
    if(cloud_account && match.params.name){
        return {
            ...alerts,
            cloud_account,
            storage : cloud_account.storages.find(i => i.bucket_name === match.params.name)
        }
    }
    return {
        ...alerts,
        cloud_account
    }
}

export default withRouter(connect(mapStateToProps,
    (dispatch) => bindActionCreators({}, dispatch))
(SetAlert))
